import { createSelector } from '@reduxjs/toolkit';
import { TypedUseQueryStateResult } from '@reduxjs/toolkit/dist/query/react';
import { MmmModelOutputDto } from './models/mmm-model-output';
import { BudgetScenarioPlannerModel } from './models/budget-scenario-planner.model';
import { BudgetScenario } from './edit-budget-scenario.slice';

type GetMmmOutputSelectFromResultArg = TypedUseQueryStateResult<
  MmmModelOutputDto[],
  any,
  any
>;
export const selectMmmOutputWithInEditBudgetScenarios = createSelector(
  (res: GetMmmOutputSelectFromResultArg) => res.data,
  (_: GetMmmOutputSelectFromResultArg, isFetching: boolean) => isFetching,
  (
    _: GetMmmOutputSelectFromResultArg,
    __: boolean,
    selectedBudgetScenario: BudgetScenario | undefined
  ) => selectedBudgetScenario,
  (
    outputs: MmmModelOutputDto[] | undefined,
    isFetching: boolean,
    selectedBudgetScenario: BudgetScenario | undefined
  ) => {
    if (isFetching) return undefined;

    if (!selectedBudgetScenario) return outputs ?? undefined;

    return (
      outputs?.map((output) => {
        const updatedValues = selectedBudgetScenario.updatedValues.find(
          (values) => values.segmentValue === output.segmentValue
        );

        if (!updatedValues) return output;
        return {
          ...output,
          mROAS: updatedValues.newMRoasValue,
          revenue: updatedValues.newRevenueValue,
          roas: updatedValues.newRoasValue,
          spend: updatedValues.newSpendValue
        };
      }) ?? undefined
    );
  }
);
